import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberTerminationStatusForm from '../../../components/forms/MemberTerminationStatusForm';
import { useCreateMemberTerminationStatus } from '../../../hooks/useMemberTerminationStatusApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { MemberTerminationStatusDTO } from '../../../services/apiClient';

const MemberTerminationStatusCreate: React.FC = () => {
  const createMutation = useCreateMemberTerminationStatus();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Member Termination Statuses', href: '/admin/memberterminationstatuses' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: MemberTerminationStatusDTO) => {
    try {
      await createMutation.mutateAsync(data);
      navigate('/admin/memberterminationstatuses');
    } catch (error) {
      console.error('Error creating MemberTerminationStatus:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/memberterminationstatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.MemberTerminationStatus.Edit'
    >
        <MemberTerminationStatusForm
          initialValues={{} as MemberTerminationStatusDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/memberterminationstatuses')}
        />
    </AdminLayout>
  );
};

export default MemberTerminationStatusCreate;